'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../node_modules/@radix-ui/react-portal/dist/index.cjs');
var React = require('react');
var InternalSnackbarItem_web = require('./InternalSnackbarItem.web.cjs');
var InternalSnackbar_web_styles = require('./InternalSnackbar.web.styles.cjs');
var index$1 = require('../../../../../../node_modules/motion/node_modules/framer-motion/dist/es/components/AnimatePresence/index.cjs');

/**
 * Internal Snackbar component that renders snackbar messages.
 * This is a controlled component that accepts messages as props.
 * For most use cases, use the `Snackbar` component instead.
 *
 * @scope Internal
 * @internal
 */ const InternalSnackbar = ({ position = "bottomRight", messages, onRemoveMessage, ...props })=>{
    const theme = react.useTheme();
    const positionMessages = React.useMemo(()=>messages.filter((message)=>message.position === position), [
        messages,
        position
    ]);
    if (positionMessages.length === 0) {
        return null;
    }
    return /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
        children: /*#__PURE__*/ jsxRuntime.jsx("div", {
            css: InternalSnackbar_web_styles.portal,
            children: /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalSnackbar_web_styles.container(theme, position),
                "data-testid": "aviary-snackbar-container",
                ...props,
                children: /*#__PURE__*/ jsxRuntime.jsx(index$1.AnimatePresence, {
                    children: positionMessages.map((message)=>/*#__PURE__*/ jsxRuntime.jsx(InternalSnackbarItem_web.InternalSnackbarItem, {
                            message: message,
                            onRemoveMessage: onRemoveMessage
                        }, message.id))
                })
            })
        })
    });
};

exports.InternalSnackbar = InternalSnackbar;
//# sourceMappingURL=InternalSnackbar.web.cjs.map
